import { render } from "./EventsWidget.vue?vue&type=template&id=27bb2fb8"
import script from "./EventsWidget.vue?vue&type=script&lang=js"
export * from "./EventsWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__